import CampaignCard from './Campaign/Card'
import CampaignStatistics from './Campaign/Statistics'
import ChartLine from './ChartJs/Line'
import Favorite from './Favorite'
import FavoriteProfile from './FavoriteProfile'
import HeaderUser from './HeaderUser'
import Empty from './Empty'
import FormSms from './Forms/Sms'
import FormSmsVars from './Forms/SmsVars'
import FormCampaignStepMessage from './Forms/Campaign/StepMessage'
import FormCampaignStepContacts from './Forms/Campaign/StepContacts'
import FormCampaignStepContactsVars from './Forms/Campaign/StepContactsVars'
import FormCampaignStepScheduling from './Forms/Campaign/StepScheduling'
import FormCampaignStepConference from './Forms/Campaign/StepConference'
import FormCampaignStepFinished from './Forms/Campaign/StepFinished'
import FormClient from './Forms/Client'
import FormCompany from './Forms/Company'
import FormContact from './Forms/Contact'
import FormImport from './Forms/Import'
import FormDefaultMessage from './Forms/DefaultMessage'
import FormGroup from './Forms/Group'
import FormUser from './Forms/User'
import GroupCard from './Groups/Card'
import GroupContacts from './Groups/Contacts'
import ConsumptionBy from './ConsumptionBy'
import Loading from './Loading'
import LoadingDialog from './LoadingDialog'
import MyBalance from './MyBalance'
import Options from './Options'
import SmsShooting from './SmsShooting'
import Submenu from './Submenu'
import TextareaVariable from './TextareaVariable'
import DownloadXlsx from './Download/Xlsx'

/**
 * Aqui você deve registrar todos os componentes personalizados
 * que foram criados na pasta '/components'
 */
export default [
    { name: 'mu-xlsx', component: DownloadXlsx },
    { name: 'mu-campaign-card', component: CampaignCard },
    { name: 'mu-campaign-statistics', component: CampaignStatistics },
    { name: 'mu-chart-line', component: ChartLine },
    { name: 'mu-favorite', component: Favorite },
    { name: 'mu-favorite-profile', component: FavoriteProfile },
    { name: 'mu-header-user', component: HeaderUser },
    { name: 'mu-empty', component: Empty },
    { name: 'mu-form-sms', component: FormSms },
    { name: 'mu-form-sms-vars', component: FormSmsVars },
    { name: 'mu-form-campaign-step-message', component: FormCampaignStepMessage },
    { name: 'mu-form-campaign-step-contacts', component: FormCampaignStepContacts },
    { name: 'mu-form-campaign-step-contacts-vars', component: FormCampaignStepContactsVars },
    { name: 'mu-form-campaign-step-scheduling', component: FormCampaignStepScheduling },
    { name: 'mu-form-campaign-step-conference', component: FormCampaignStepConference },
    { name: 'mu-form-campaign-step-finished', component: FormCampaignStepFinished },
    { name: 'mu-form-client', component: FormClient },
    { name: 'mu-form-company', component: FormCompany },
    { name: 'mu-form-contact', component: FormContact },
    { name: 'mu-form-import', component: FormImport },
    { name: 'mu-form-default-message', component: FormDefaultMessage },
    { name: 'mu-form-group', component: FormGroup },
    { name: 'mu-form-user', component: FormUser },
    { name: 'mu-group-card', component: GroupCard },
    { name: 'mu-group-contacts', component: GroupContacts },
    { name: 'mu-consumption-by', component: ConsumptionBy },
    { name: 'mu-loading', component: Loading },
    { name: 'mu-loading-dialog', component: LoadingDialog },
    { name: 'mu-my-balance', component: MyBalance },
    { name: 'mu-options', component: Options },
    { name: 'mu-sms-shooting', component: SmsShooting },
    { name: 'mu-submenu', component: Submenu },
    { name: 'mu-textarea-variable', component: TextareaVariable }
]
